/**
 * CSS Variables 设计令牌统一管理
 *
 * 引用方可通过在父容器设置同名 CSS 变量来覆盖组件样式：
 * .my-app { --xadk-color-primary: #7c3aed; }
 */

/** CSS 变量名常量 */
export const tokens = {
  // 颜色
  colorPrimary: "--xadk-color-primary",
  colorSuccess: "--xadk-color-success",
  colorError: "--xadk-color-error",
  colorWarning: "--xadk-color-warning",
  colorTextSecondary: "--xadk-color-text-secondary",
  colorBorder: "--xadk-color-border",
  colorBgHover: "--xadk-color-bg-hover",

  // 字体
  fontSizeSm: "--xadk-font-size-sm",
  fontSizeBase: "--xadk-font-size-base",

  // 圆角
  borderRadius: "--xadk-border-radius",

  // 间距
  spacingSm: "--xadk-spacing-sm",
  spacingMd: "--xadk-spacing-md",
} as const;

/** 默认值映射 */
export const tokenDefaults: Record<string, string> = {
  [tokens.colorPrimary]: "#0078FF",
  [tokens.colorSuccess]: "#52c41a",
  [tokens.colorError]: "#ff4d4f",
  [tokens.colorWarning]: "#faad14",
  [tokens.colorTextSecondary]: "#8194ad",
  [tokens.colorBorder]: "#e5e5e5",
  [tokens.colorBgHover]: "#f5f5f5",
  [tokens.fontSizeSm]: "12px",
  [tokens.fontSizeBase]: "13px",
  [tokens.borderRadius]: "8px",
  [tokens.spacingSm]: "8px",
  [tokens.spacingMd]: "16px",
};

/** 生成 var() 引用（带 fallback 默认值） */
export const token = (name: string, fallback?: string): string => {
  const defaultVal = fallback ?? tokenDefaults[name];
  return defaultVal ? `var(${name}, ${defaultVal})` : `var(${name})`;
};

/** 将 tokenDefaults 转为可注入到 style 属性的对象 */
export const cssVarStyle: Record<string, string> = { ...tokenDefaults };
